import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";
import CRUDTable from "../CRUDTable";
import {formAttributeMappingCRUD, formAttributeCRUD} from "../../../http";
import {FORM_ATTRIBUTE_MAPPING_DETAIL_ROUTE} from "../../../routes";
import React from "react";
import { page } from "../../../functions/resourceLinq1";
import { mapOrganizationValues } from "../../../functions/viewDataMap";

export default function FormAttributeMappingCRUDTable({...props}) {
    const {t} = useTranslation();
    const {push} = useHistory();

    const fallbackTypes = ['objectReferral', 'act', 'result', 'protocol', 'prescription', 'resolution', 'referral'];
    const [typeOptions, setTypeOptions] = React.useState(fallbackTypes.map(type => ({ id: type, name: type })));
    const [attrMap, setAttrMap] = React.useState({});

    React.useEffect(() => {
        (async function loadTypes() {
            try {
                const list = await formAttributeCRUD.toList(page(null, 0, null));
                const types = Array.from(new Set((list || []).map(_ => _.type).filter(Boolean)));
                const opts = (types.length > 0 ? types : fallbackTypes).map(type => ({ id: type, name: type }));
                setTypeOptions(opts);
                const map = {};
                (list || []).forEach(a => {
                    if (a && a.type && a.member) {
                        map[`${a.type}|${a.member}`] = a.memberDescription || '';
                    }
                });
                setAttrMap(map);
            } catch (e) {
                // keep fallback options
            }
        })();
    }, []);

    const columns = [
        {title: t("formAttributeMappingList.tableItem.id"), dataIndex: "id", key:"id"},
        {title: t("formAttributeMappingList.tableItem.sourceType"), dataIndex: "sourceType", key:"sourceType"},
        {title: t("formAttributeMappingList.tableItem.sourceMember"), dataIndex: "sourceMember", key:"sourceMember", render: (unknown, row) => {
            const desc = `${row?.sourceType} | ${row?.sourceMember}`;
            return desc || row.sourceMember || <span style={{color: "gray"}}>Не задано</span>;
        }},
        {title: t("formAttributeMappingList.tableItem.targetType"), dataIndex: "targetType", key:"targetType"},
        {title: t("formAttributeMappingList.tableItem.targetMember"), dataIndex: "targetMember", key:"targetMember", render: (unknown, row) => {
            const desc = `${row?.targetType} | ${row?.targetMember}`;
            return desc || row.targetMember || <span style={{color: "gray"}}>Не задано</span>;
        }},
        {title: t("formAttributeMappingList.tableItem.targetNumber"), dataIndex: "targetNumber", key:"targetNumber", render: (unknown, row) => row.targetNumber ? row.targetNumber : <span style={{color: "gray"}}>Не задано</span>},
        {title: t("formAttributeMappingList.tableItem.hasMappingFunction"), dataIndex: "sourceMemberMap", key:"sourceMemberMap", render: (unknown, row) => row.sourceMemberMap ? "Да" : "Нет"},
        {title: t("formAttributeMappingList.tableItem.enabled"), dataIndex: "enabled", key:"enabled", render: (val) => (val === true ? "Да" : val === false ? "Нет" : <span style={{color: "gray"}}>Не задано</span>)},
    ]

    const filterFields = [        
        {
            title: "Тип источника", 
            key: "sourceType", 
            type:"normal", 
            compareType: "equals", 
            options: typeOptions,
            operandPosition: 1, 
            filterType: "normal", 
            optionLabelKey: "name"},
        {
            title: "Тип цели", 
            type:"normal", 
            key: "targetType", 
            compareType: "equals", 
            operandPosition: 1, 
            filterType: "normal", 
            options: typeOptions, 
            optionLabelKey: "name"}
    ]

    const searchFields = [
        {
            title: "Поле источника",
            key: "sourceMember",
            compareType: "equals",
            operandPosition:1,
            filterType:"normal"
        },
        {
            title: "Поле цели",
            key: "targetMember",
            compareType: "equals",
            operandPosition:1,
            filterType:"normal"
        }
    ]

    return <CRUDTable
        search={formAttributeMappingCRUD.search}
        columns={columns}
        onClickCreateButton={() => push(FORM_ATTRIBUTE_MAPPING_DETAIL_ROUTE("new"))}
        searchFields={searchFields}
        filterFields={filterFields}
        {...props}
    />
} 